import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { DatePicker } from '@mui/x-date-pickers';
import { useDownloadCSVFile } from '../hooks/useDownloadCSV';
import { format } from 'date-fns';
import { toast } from 'react-toastify';

interface ModalTypes {
  open: boolean;
  setOpen: (t: boolean) => void;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function DownloadFileModal({ open, setOpen }: ModalTypes) {
  const handleClose = () => {
    setOpen(false);
  };

  const [startDate, setStartDate] = React.useState<Date | null>(new Date());
  const [endDate, setEndDate] = React.useState<Date | null>(new Date());

  const { downloadFile } = useDownloadCSVFile();

  const handleButtonClick = () => {
    if (startDate && endDate) {
      const formattedStartDate: string = format(startDate, 'yyyy-MM-dd');
      const formattedEndDate: string = format(endDate, 'yyyy-MM-dd');

      void downloadFile(formattedStartDate, formattedEndDate);
      handleClose();
    } else {
      toast.error('Start date or end date is missing.');
    }
  };

  return (
    <React.Fragment>
      <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Download CSV File
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <div className="flex gap-5">
            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={(newValue: Date | null) => setStartDate(newValue)}
            />
            <DatePicker label="End Date" value={endDate} onChange={(newValue: Date | null) => setEndDate(newValue)} />
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleButtonClick}>
            Export
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
